import { Breakpoint } from "@omni/types/enums/breakPoint.enum";
import { description } from "@omni/ui/components/Product/ProductTile/components/description.style";
import { tv } from "tailwind-variants";

const base = tv({
    base: ["tw:bg-white tw:h-full tw:flex-col tw:relative"],
    variants: {
        breakpoint: {
            "none": "tw:flex",
            [Breakpoint.xs]: "tw:xs:flex",
            [Breakpoint.sm]: "tw:sm:flex",
            [Breakpoint.md]: "tw:md:flex",
            [Breakpoint.lg]: "tw:lg:flex",
            [Breakpoint.xl]: "tw:xl:flex"
        },
        link: {
            true: "tw:cursor-pointer",
            false: "tw:cursor-default"
        },
        hover: {
            true: "",
            false: ""
        },
        border: {
            true: "tw:shadow-card tw:rounded-md tw:p-3",
            false: ""
        },
        padding: {
            true: "tw:p-3",
            false: ""
        }
    },
    compoundVariants: [
        {
            hover: true,
            border: true,
            className:
                "tw:transition-transform tw:backface-hidden tw:hover:bg-white tw:hover:scale-102 tw:hover:shadow-card-active tw:group-[*]/productTile-active:bg-white tw:group-[*]/productTile-active:scale-102 tw:group-[*]/productTile-active:shadow-card-active"
        }
    ],
    defaultVariants: {
        breakpoint: "none"
    }
});

export const ProductTileStyle = Object.assign(base, {
    description: description
});
